import axios from 'axios';
import type { UserPreferences } from '~/generated/prisma';

export interface UserPreferencesResponse {
  success: boolean;
  data: UserPreferences;
  message?: string;
}

export interface UpdateNotificationPreferencesData {
  emailNotifications?: boolean;
  extractionComplete?: boolean;
  paymentConfirmation?: boolean;
  weeklyReport?: boolean;
  marketingEmails?: boolean;
  securityAlerts?: boolean;
  creditLowAlert?: boolean;
  newFeatures?: boolean;
}

export interface UpdatePrivacyPreferencesData {
  dataRetentionDays?: number;
}

/**
 * Get current user's preferences
 * @returns Promise with user preferences
 */
export const getPreferencesApi = async (): Promise<UserPreferences> => {
  const response = await axios.get<UserPreferencesResponse>(
    '/api/user/preferences',
  );
  return response.data.data;
};

/**
 * Update notification preferences
 * @param data - Notification preferences to update
 * @returns Promise with updated preferences
 */
export const updateNotificationPreferencesApi = async (
  data: UpdateNotificationPreferencesData,
): Promise<UserPreferences> => {
  const response = await axios.patch<UserPreferencesResponse>(
    '/api/user/preferences',
    data,
  );
  return response.data.data;
};

/**
 * Update privacy preferences
 * @param data - Privacy preferences to update
 * @returns Promise with updated preferences
 */
export const updatePrivacyPreferencesApi = async (
  data: UpdatePrivacyPreferencesData,
): Promise<UserPreferences> => {
  const response = await axios.patch<UserPreferencesResponse>(
    '/api/user/preferences',
    data,
  );
  return response.data.data;
};
